import apiService from '@/services/apiService';

const actions = {
  getMeta({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.get(`paxel-recycle/meta`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  postMeta({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/meta', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
